import { useRouter } from 'next/router';
import { Stack, Typography } from '@mui/material';
import { ChartPie, Signal, User } from 'lucide-react';

import { useAuth } from '@savvy/deprecated-shared/hooks/use-auth';
import { neutral } from '@savvy/deprecated-shared/theme';
import { XNavLink } from '@savvy/deprecated-shared/x-components/x-nav-link';

export function XMobileBottomNav() {
  const router = useRouter();
  const { user } = useAuth();

  const getColor = (path: string) => {
    if (path === router.asPath || router.asPath.includes(path)) {
      return '#175242';
    }
    return neutral[400];
  };
  const portfolioItem =
    user?.role === 'NON_ADVISORY_USER'
      ? undefined
      : {
          title: 'Portfolio',
          path: `/savvy-portfolio/${user?.personalPortfolioId}`,
          icon: <ChartPie color={getColor('/savvy-portfolio')} size={24} />,
        };

  const menuItems = [
    {
      title: 'Net Worth',
      path: '/portfolio',
      icon: <Signal color={getColor('/portfolio')} size={24} />,
    },
    portfolioItem,
    {
      title: 'My Account',
      path: '/dashboard/account',
      icon: <User color={getColor('/dashboard/account')} size={24} />,
    },
  ];

  return (
    <Stack
      sx={{
        width: '100%',
        height: 56,
        borderTop: `1px solid ${neutral[200]}`,
        backgroundColor: neutral[0],
        position: 'fixed',
        bottom: 0,
        zIndex: 10,
        px: 5,
      }}
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      {menuItems.map(
        (item) =>
          item && (
            <XNavLink href={item.path} key={item.path}>
              <Stack alignItems="center">
                {item.icon}
                <Typography
                  sx={{
                    color: getColor(item.path),
                    fontSize: '9px',
                    fontWeight: 500,
                  }}
                >
                  {item.title}
                </Typography>
              </Stack>
            </XNavLink>
          ),
      )}
    </Stack>
  );
}
